import clsx from "clsx"
import { FC, memo } from "react"
import { GameEffectFrameImg, GameEffectPlaceholderImg } from "@/assets"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./EffectFrame.module.scss"
import { IEffectFrame } from "./types"

const EffectFrameComponent: FC<IEffectFrame> = ({
  effect,
  isActiveEffect,

  className,
  ...props
}) => {
  return (
    <div className={clsx(styles.EffectFrame, className)} {...props}>
      <div className={clsx(styles.EffectFrame_frame)}>
        <img
          src={effect ? GameEffectFrameImg : GameEffectPlaceholderImg}
          alt="effect frame"
        />
      </div>

      {!!effect && (
        <>
          <div className={clsx(styles.EffectFrame_content)}>
            <img src={effect.usedCardImgSrc} alt="effect content" />
          </div>

          {isActiveEffect && effect.remainingMovements > 0 && (
            <OutlinedText className={clsx(styles.EffectFrame_counter)}>
              {effect.remainingMovements}
            </OutlinedText>
          )}
        </>
      )}
    </div>
  )
}

export const EffectFrame = memo(EffectFrameComponent)
